import { inWindow } from 'api';
import { MailSign, PreHeader, MailSignEnt, emptyLine, SocialLink, UnSubText, SubText, MailPreMailContent, MailForwardContent } from './mailClassnameConstant';
import './tempNode.css';
export const deleteNode = (root, selector) => {
    const removeNode = root.querySelector(selector);
    removeNode === null || removeNode === void 0 ? void 0 : removeNode.remove();
};
const deleteAllNode = (root, selector) => {
    const removeNodes = root.querySelectorAll(selector);
    removeNodes.forEach(node => node.remove());
};
const dealGuide = (root) => {
    const GuideWrap = '.guide-wrap';
    const guideWrap = root.querySelector(GuideWrap);
    if (guideWrap) {
        const guideContNodes = root.querySelectorAll('.guide-content');
        const realGuideContent = document.createElement('div');
        guideContNodes.forEach(item => {
            var _a;
            const innText = (_a = item) === null || _a === void 0 ? void 0 : _a.innerText;
            if (innText && !/^\s+$/g.test(innText)) {
                realGuideContent.innerText += innText;
            }
        });
        guideWrap.innerHTML = '';
        guideWrap.appendChild(realGuideContent);
        if (!realGuideContent.innerText)
            deleteAllNode(root, GuideWrap);
    }
};
const deleteNodeText = (root, content, selector) => {
    const removeNode = root.querySelector(selector);
    if (removeNode) {
        const test = removeNode.innerText;
        content.replace(test, '');
    }
    return content;
};
export const getMailContentText = (params) => {
    const { content, removeUnSubText, withSign, filterGuide } = params;
    if (!inWindow()) {
        return '';
    }
    const tempNode = document.querySelector('.aiWrite-temp-node');
    const node = tempNode !== null && tempNode !== void 0 ? tempNode : document.createElement('div');
    node.className = 'aiWrite-temp-node';
    node.innerHTML = content || '';
    if (!withSign) {
        deleteAllNode(node, `.${MailSign}`);
    }
    deleteAllNode(node, `.${SocialLink}`);
    deleteAllNode(node, `[editVar="true"]`);
    deleteNode(node, `#${PreHeader}`);
    deleteAllNode(node, `.${MailSignEnt}`);
    deleteNode(node, `.${MailPreMailContent}`);
    deleteNode(node, `#${MailForwardContent}`);
    deleteAllNode(node, `style`);
    deleteAllNode(node, `title`);
    filterGuide && dealGuide(node);
    if (removeUnSubText) {
        deleteAllNode(node, `.${UnSubText}`);
        deleteAllNode(node, `.${SubText}`);
    }
    if (!tempNode) {
        document.body.appendChild(node);
    }
    setTimeout(() => {
        node.remove();
    }, 100);
    return node.innerText.trim();
};
export const getContentWithoutSign = (content, type) => {
    const node = document.createElement('div');
    node.innerHTML = content;
    deleteNode(node, `.${MailSign}`);
    deleteNode(node, `#${PreHeader}`);
    deleteNode(node, `.${MailSignEnt}`);
    deleteAllNode(node, `style`);
    deleteAllNode(node, `title`);
    if (type === 'html') {
        return node.innerHTML;
    }
    return node.innerText.trim();
};
export const getContentWithoutSignOnly = (content) => {
    if (!content) {
        return '';
    }
    const node = document.createElement('div');
    node.innerHTML = content;
    deleteNode(node, `.${MailSign}`);
    deleteNode(node, `#${PreHeader}`);
    deleteNode(node, `.${MailSignEnt}`);
    return node.outerHTML;
};
export const isEmpty = (content) => {
    const node = document.createElement('div');
    node.innerHTML = content;
    deleteNode(node, `.${MailSign}`);
    deleteNode(node, `#${PreHeader}`);
    deleteNode(node, `.${MailSignEnt}`);
    return node.innerText.trim().length < 1;
};
export function contentWithoutEmpty(content) {
    const node = document.createElement('div');
    node.innerHTML = content;
    deleteNode(node, `.${emptyLine}`);
    return node.innerHTML;
}
export const addDataSrcForImg = (html) => {
    const imgs = html.querySelectorAll('img');
    imgs.forEach(img => {
        img.dataset.src = 'template';
    });
    return html;
};
